export const calculateFlatDiscount = ({
  flatDiscount,
  totalValue,
}: {
  flatDiscount: number;
  totalValue: number;
}) => {
  if (flatDiscount < 0) {
    return 0;
  }
  return flatDiscount > totalValue ? totalValue : flatDiscount;
};
